import React from 'react';
import { Header } from './header';
import { Footer } from './footer';
import { PageWrapper as StyledPageWrapper, MainContent, Container } from './page-wrapper.styles';

interface PageWrapperProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  contained?: boolean;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  contained = false,
}) => (
  <StyledPageWrapper>
    {showHeader && <Header />}
    <MainContent>
      {contained ? <Container>{children}</Container> : children}
    </MainContent>
    {showFooter && <Footer />}
  </StyledPageWrapper>
);
